import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { InvestmentProgrammeSigningRolesRes } from '@dealstack/shared/lib/generated';

type Options = Omit<
	UseQueryOptions<
		ApiV1.Response<InvestmentProgrammeSigningRolesRes>,
		Error,
		InvestmentProgrammeSigningRolesRes,
		[string, { dealId: string; programmeId: string }]
	>,
	'queryKey' | 'queryFn' | 'select'
> & {
	dealId: string;
	programmeId: string;
};

export const useInvestmentProgrammeSigningRoles = (options: Options) => {
	const { dealId, programmeId, ...queryOptions } = options;

	const signingRolesEndpoint = formatUnicorn(
		API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_SIGNING_ROLES_GET,
		{ dealId, programmeId }
	);

	return useQuery({
		enabled: !!dealId && !!programmeId,
		queryKey: [signingRolesEndpoint, { dealId, programmeId }],
		queryFn: async () => {
			const response = await makeRequest<ApiV1.Response<InvestmentProgrammeSigningRolesRes>>({
				endpoint: signingRolesEndpoint,
				method: HTTP_METHOD.GET,
			});
			return response;
		},
		select: (data) => {
			return data.payload?.signingRoles;
		},
		...queryOptions,
	});
};
